import { itemAvatarPalette, itemInitials } from '../services/itemAvatar'

/**
 * 保管庫アイテムの文字アバター (ookey-browser `.vault-favicon` 準拠)。
 *
 * 名前から決定的に選んだ tint 背景 + 同系色文字のイニシャルバッジ。形状 / サイズ /
 * 影は `.vault-item-avatar` CSS が担当し、bg / color は per-item で変わるため inline
 * style で渡す (CLAUDE.md §6.5 の動的色 inline 許容例)。
 */
export interface VaultItemAvatarProps {
  /** アイテム名 (URL の場合は domain からイニシャル / 色を導出)。 */
  name: string
  /** サイズ variant。sm=32px (一覧行) / md=40px (お気に入り) / lg=48px (詳細)。default sm。 */
  size?: 'sm' | 'md' | 'lg'
  /** grid 配置等の layout フック用に追加する class (例: 一覧行の `vault-row-icon`)。 */
  className?: string
}

export const VaultItemAvatar = ({
  name,
  size = 'sm',
  className,
}: VaultItemAvatarProps): JSX.Element => {
  const palette = itemAvatarPalette(name)

  const sizeClass =
    size === 'lg' ? ' vault-item-avatar--lg' : size === 'md' ? ' vault-item-avatar--md' : ''

  return (
    <span
      className={`vault-item-avatar${sizeClass}${className ? ` ${className}` : ''}`}
      style={{ background: palette.bg, color: palette.fg }}
      aria-hidden="true"
    >
      {itemInitials(name)}
    </span>
  )
}
